import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DisplayMessage } from '../../core/messages/display-message';
import { DisplayMessages } from '../../core/messages/display-messages';
import { Severity } from '../../shared/enums/severity';

/**
 * Validates node process and function expressions
 */
@Injectable()
export class ExpressionValidatorService {

  /**
   * Validation results with message text and severity level
   */
  public messages: BehaviorSubject<DisplayMessages> = new BehaviorSubject<DisplayMessages>(
    new DisplayMessages());

  constructor() {}

  public getSeverity(severity: Severity): string {
    switch (severity) {
    case Severity.Success:
      return 'success';
    case Severity.Warning:
      return 'warn';
    case Severity.Error:
      return 'error';
    case Severity.Information:
      return 'info';
    }
  }

  /**
   * Validates node process of function expression text
   * @param text process text to validate
   */
  public validate(text: string): void {
    const result: DisplayMessages = new DisplayMessages();

    const parentheses: DisplayMessage = this.validateParentheses(text);
    if (parentheses.severity !== this.getSeverity(Severity.Success)) {
      result.addMessage(parentheses);
    }

    this.messages.next(result);
  }

  validateParentheses(text: string): DisplayMessage {
    let counter = 0;
    let i: number;
    for (i = 0; i < text.length; i++) {
      if (text[i] === '(') {
        counter++;
      } else if (text[i] === ')') {
        counter--;
      }
      if (counter < 0) {
        return new DisplayMessage('', '( expected', Severity.Warning);
      }
    }

    if (counter > 0) {
      return new DisplayMessage('', ') expected', Severity.Warning);
    }
    return new DisplayMessage('', '', Severity.Success);
  }
}
